import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="servicegebuehr-modus"
export default class extends Controller {
	static targets = ["einfacheGebuehr", "staffelContainer"]

	connect() {}

	update({ currentTarget }) {
		if (currentTarget.value == "keine_staffel") {
			this.hideStaffel()
		} else {
			this.showStaffel()
		}
	}

	// Private Methods

	hideStaffel() {
		this.einfacheGebuehrTarget.classList.remove("hidden")
		this.staffelContainerTarget.classList.add("hidden")
	}

	showStaffel() {
		this.einfacheGebuehrTarget.classList.add("hidden")
		this.staffelContainerTarget.classList.remove("hidden")
	}
}
